export function isProfessionCityPageEmpty(professionals) {
  return (
    Array.isArray(professionals?.people) && professionals.people.length === 0
  );
}
